function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#f)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 28,
  fill: "white"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 35,
  r: 27.575,
  stroke: "#EEEEEE",
  strokeWidth: 0.85
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.7517 26H30.3683C30.9776 26 31.1979 26.0604 31.421 26.1723C31.6412 26.2824 31.8212 26.4527 31.9378 26.6609C32.0561 26.8717 32.12 27.08 32.12 27.656V42.344C32.12 42.92 32.0561 43.1283 31.9378 43.3391C31.8212 43.5473 31.6412 43.7176 31.421 43.8277C31.1979 43.9396 30.9776 44 30.3683 44H27.7517C27.1424 44 26.9221 43.9396 26.699 43.8277C26.4788 43.7176 26.2988 43.5473 26.1822 43.3391C26.0639 43.1283 26 42.92 26 42.344V27.656C26 27.08 26.0639 26.8717 26.1822 26.6609C26.2988 26.4527 26.4788 26.2824 26.699 26.1723C26.9221 26.0604 27.1424 26 27.7517 26ZM38.6317 26H41.2483C41.8576 26 42.0779 26.0604 42.301 26.1723C42.5212 26.2824 42.7012 26.4527 42.8178 26.6609C42.9361 26.8717 43 27.08 43 27.656V42.344C43 42.92 42.9361 43.1283 42.8178 43.3391C42.7012 43.5473 42.5212 43.7176 42.301 43.8277C42.0779 43.9396 41.8576 44 41.2483 44H38.6317C38.0224 44 37.8021 43.9396 37.579 43.8277C37.3588 43.7176 37.1788 43.5473 37.0622 43.3391C36.9439 43.1283 36.88 42.92 36.88 42.344V27.656C36.88 27.08 36.9439 26.8717 37.0622 26.6609C37.1788 26.4527 37.3588 26.2824 37.579 26.1723C37.8021 26.0604 38.0224 26 38.6317 26Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "f",
  x: 0,
  y: 0,
  width: 70,
  height: 70,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 34.5,
  y1: 26,
  x2: 34.5,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6CC584"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71CC8B"
})));

var SvgTimerPauseBtn = function SvgTimerPauseBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimerPauseBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timer-pause-btn.5bb9f5af.svg";
export { ForwardRef as ReactComponent };